import {max} from "lodash";
import {Bar} from "../../interfaces/Bar";

export function findFreshest(bars: Bar[]): number|undefined {
    const timestamps= bars.map(value => value.updated_at ?? 0)
    const result = max(timestamps)
    if (result == 0) return undefined
    else return result
}